import { operatorDefinitions } from '../../operators';

export const createNullExpression = (): {
  operator: string;
  type: string;
} => ({
  operator: operatorDefinitions.null.operator,
  type: 'null',
});
